import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AdminBuyerListsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const adminBuyerListsQuery = graphql(`
  query adminBuyerLists($userId: String!) {
    adminBuyerLists(userId: $userId) {
      id
      name
      ownerId
      companyId
      sharingType
      createdAt
      updatedAt
      isDeleted
    }
  }
`);

/** Fetch all buyer lists for a user by userId (admin — includes soft-deleted). */
export function useAdminBuyerLists(
  userId: string,
  options?: UseQueryOptions<AdminBuyerListsQuery, unknown, AdminBuyerListsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["buyerLists", userId],
    adminBuyerListsQuery,
    [{ userId }],
    options,
  );
  return { data: data?.adminBuyerLists, ...rest };
}
